import { AuthenticationType, DataLocationStorageType, parameterType, } from '../models/DataSourceDataCommon';
import { notDeleteKey } from '../../DataSourceDetail/ducks/DataSourceDetailConstants';
import { compareIgnoreCase } from '@ane/core/lib/utils/CommonStringUtils';
import _ from 'lodash';
import { MTLocation } from '../../../constants/DataSource.DataLocation.constants';
import { ProfilingOptions } from '../components/DataProfiling/DataProfilingComponent';
import EnvironmentService from '@ane/core/lib/services/EnvironmentService';
import { isClassicWorkspaceById } from '@ane/exp-data/lib/utils/ManagementGroup';
export var dataSourceCreateComponentsName;
(function (dataSourceCreateComponentsName) {
    dataSourceCreateComponentsName["basicinfo"] = "basicinfo";
    dataSourceCreateComponentsName["datalocationinfo"] = "datalocationinfo";
    dataSourceCreateComponentsName["specialcolumns"] = "specialcolumns";
    dataSourceCreateComponentsName["parametersinfo"] = "parametersinfo";
    dataSourceCreateComponentsName["availabilitystreaminfo"] = "availabilitystreaminfo";
})(dataSourceCreateComponentsName || (dataSourceCreateComponentsName = {}));
export const getValidateCosmosDateTimeDiff = (start, end) => {
    if (start && end) {
        const startNumber = Number.parseInt(start);
        const endNumber = Number.parseInt(end);
        if (isNaN(startNumber)) {
            return 'StartDate offset must be less than 0.';
        }
        if (isNaN(endNumber)) {
            return 'EndDate offset must be less than 0.';
        }
        if (startNumber >= 0) {
            return 'StartDate offset must be less than 0.';
        }
        if (startNumber < -365) {
            return 'StartDate offset cannot be less than -365.';
        }
        if (endNumber >= 0) {
            return 'EndDate offset must be less than 0.';
        }
        if (startNumber > endNumber) {
            return 'EndDate offset cannot be less than StartDate offset.';
        }
        if (startNumber < 0 && startNumber >= -365 && endNumber < 0 && endNumber - startNumber <= 5 && endNumber - startNumber >= 0) {
            return '';
        }
        else {
            return 'StartDate and EndDate offsets are not allowed to differ by more than 5.';
        }
    }
    else {
        return '';
    }
};
(function (dataSourceCreateComponentsName) {
    dataSourceCreateComponentsName["retentiondays"] = "retentiondays";
    dataSourceCreateComponentsName["url"] = "url";
    dataSourceCreateComponentsName["cluster"] = "cluster";
    dataSourceCreateComponentsName["system.string"] = "system.string";
    dataSourceCreateComponentsName["system.boolean"] = "system.boolean";
    dataSourceCreateComponentsName["system.int32"] = "system.int32";
    dataSourceCreateComponentsName["cosmosdatenumberend"] = "cosmosdatenumberend";
    dataSourceCreateComponentsName["cosmosdatenumberstart"] = "cosmosdatenumberstart";
    dataSourceCreateComponentsName["system.double"] = "system.double";
    dataSourceCreateComponentsName["system.int64"] = "system.int64";
})(dataSourceCreateComponentsName || (dataSourceCreateComponentsName = {}));
export const getValidateMessage = (name, value, IsADLSGen2AndUsingSP) => {
    if (!value || '' === value.trim()) {
        if (IsADLSGen2AndUsingSP) {
            switch (name.toLowerCase()) {
                case 'url':
                    return '';
                case 'secretname':
                    return '';
                default:
                    return 'Required';
            }
        }
        switch (name.toLowerCase()) {
            case 'retentiondays':
                return '';
            case 'retentiondayserrormsg':
                return '';
            default:
                return 'Required';
        }
    }
    switch (name.toLowerCase()) {
        case 'retentiondays':
            const isValueValid = !isNaN(Number(value)) || value === '';
            let errorMessage = '';
            if (!isValueValid) {
                errorMessage = 'Please enter a number';
            }
            else if (Number(value) <= 0) {
                errorMessage = 'The valid data period must be a positive integer.';
            }
            return errorMessage;
        case 'url':
            try {
                new URL(value);
            }
            catch (_) {
                return 'Require URL';
            }
            return '';
        case 'cluster':
            if (!validateCluster(value.toLowerCase())) {
                return 'For example vc://cosmos{ClusterNumber} or https://[aad].{ClusterName}.osdinfra.net/cosmos';
            }
            else {
                return '';
            }
        case 'system.string':
            if (!validateParameter(value, name)) {
                return 'String should be double quoted';
            }
            else {
                return '';
            }
        case 'system.boolean':
            if (!validateParameter(value, name)) {
                return 'Require bool type';
            }
            else {
                return '';
            }
        case 'system.int32':
        case 'system.int64':
            if (!validateParameter(value, name)) {
                return 'Require integer type';
            }
            else {
                return '';
            }
        case 'system.double':
            if (!validateParameter(value, name)) {
                return 'Require double type';
            }
            else {
                return '';
            }
        case 'cosmosdatenumberstart':
            if (!validateParameter(value, name)) {
                return 'StartDate offset must be less than 0.';
            }
            else {
                return '';
            }
        case 'cosmosdatenumberend':
            if (!validateParameter(value, name)) {
                return 'EndDate offset must be less than 0.';
            }
            else {
                return '';
            }
        default:
            return '';
    }
};
export const validateCluster = (cluster) => {
    cluster = cluster.toLowerCase();
    return /^https:\/\/(aad\.)?.*\.osdinfra\.net\/cosmos$/.test(cluster) || /^vc:\/\/cosmos[0-9]+(\/)?$/.test(cluster);
};
export const validateParameter = (parameter, type) => {
    if (!parameter || '' === parameter.trim()) {
        return false;
    }
    switch (type.toLocaleLowerCase()) {
        case 'system.string':
            return /^".*"+$/.test(parameter);
        case 'system.int32':
        case 'system.int64':
            return /^[-+]?[0-9]+$/.test(parameter);
        case 'cosmosdatenumber':
            return /^[-][0-9]+$/.test(parameter) && Number.parseInt(parameter) < 0 && Number.parseInt(parameter) >= -365;
        case 'system.double':
            return /^([-+]?\d+)(\.\d+)?$/.test(parameter);
        case 'system.boolean':
        default:
            return true;
    }
};
/**
 * TODO
 * Migrate all descriptive text to separate util - getFieldDescription
 */
export const getPlaceHolder = (component, name, storageType = '') => {
    var _a;
    const placeholderDict = {
        [dataSourceCreateComponentsName.basicinfo + '_owners']: 'Tab separated list of user aliases',
        [dataSourceCreateComponentsName.basicinfo + '_isutc']: 'Please select the time zone is UTC or not',
        // DataLocationInfo
        [dataSourceCreateComponentsName.datalocationinfo + '_cosmos_cluster']: 'For example vc://cosmos09 or https://cosmos09.osdinfra.net/cosmos',
        [dataSourceCreateComponentsName.datalocationinfo + '_cosmos_vc']: 'Provide the VC name',
        [dataSourceCreateComponentsName.datalocationinfo + '_cosmos_datapath']: 'Provide the data path',
        [dataSourceCreateComponentsName.datalocationinfo + '_mt_datapath']: 'For example /Event/eventYear={YYYY}/eventMonth={MM}/eventDay={DD}/*.parquet',
        [dataSourceCreateComponentsName.datalocationinfo + '_azureblob_datapath']: 'For example /Event/eventYear={YYYY}/eventMonth={MM}/eventDay={DD}/*.parquet',
        [dataSourceCreateComponentsName.datalocationinfo + '_adlsgen2_datapath']: 'For example /Event/eventYear={YYYY}/eventMonth={MM}/eventDay={DD}/*.parquet',
        [dataSourceCreateComponentsName.datalocationinfo + '_adlsgen2_url']: 'Provide the ADLS Gen2 key vault URL',
        [dataSourceCreateComponentsName.datalocationinfo + '_adlsgen2_secretname']: 'Provide the ADLS Gen2 Secret Name',
        [dataSourceCreateComponentsName.datalocationinfo + '_datatype']: 'Please select the data type',
        // SpecialColumns
        [dataSourceCreateComponentsName.specialcolumns + '_columnname']: 'Enter column name',
        [dataSourceCreateComponentsName.specialcolumns + '_format']: 'Select flight format',
        // ParametersInfo
        [dataSourceCreateComponentsName.parametersinfo + '_name']: name,
        [dataSourceCreateComponentsName.parametersinfo + '_type']: name,
        [dataSourceCreateComponentsName.parametersinfo + '_value']: 'Parameter value',
        [dataSourceCreateComponentsName.parametersinfo + '_samplevalue']: 'Parameter sample value',
        // Availability Stream Info
        [dataSourceCreateComponentsName.availabilitystreaminfo + '_cluster']: 'For example https://cosmos09.osdinfra.net/cosmos',
        [dataSourceCreateComponentsName.availabilitystreaminfo + '_vc']: 'searchDMProd',
        [dataSourceCreateComponentsName.availabilitystreaminfo + '_datapath']: 'For example /shares/bus.prod/local/office/Aggregated/Datasets/Public/FlightAssignment/EXO/EXOVariantConfig/%Y/%m/EXOVariantConfigCompact_%Y_%m_%d.ss',
        [dataSourceCreateComponentsName.datalocationinfo + '_mt_region']: 'E.g.: CO4-3',
        [dataSourceCreateComponentsName.datalocationinfo + '_mt_endpoint']: 'E.g.: CO4-3',
        [dataSourceCreateComponentsName.datalocationinfo + '_mt_serviceprincipalname']: 'Please select your service principal',
    };
    let key = component;
    if (storageType) {
        key += '_' + storageType;
    }
    key = (key + '_' + name).toLowerCase();
    if (placeholderDict[key]) {
        return placeholderDict[key];
    }
    const displayStorageTypeDict = {
        [DataLocationStorageType.ADLSGen2]: 'ADLS Gen2',
        [DataLocationStorageType.AzureBlob]: 'Azure Blob',
    };
    const displayStorageType = (_a = displayStorageTypeDict[storageType]) !== null && _a !== void 0 ? _a : storageType;
    switch (name) {
        case 'DataPath':
            return 'For example /Event/eventYear={YYYY}/eventMonth={MM}/eventDay={DD}/*.parquet';
        case 'StorageAccount':
            return `Provide the ${displayStorageType} storage account`;
        case 'Container':
            return `Provide the ${displayStorageType} storage container`;
        default:
            return `Provide a descriptive ${name}`;
    }
};
export var DataType;
(function (DataType) {
    DataType["CosmosCosmosView"] = "Cosmos-CosmosView";
    DataType["AzureBlobParquet"] = "AzureBlob-Parquet";
    DataType["ADLSGen2Parquet"] = "ADLSGen2-Parquet";
    DataType["ADLSGen2CosmosView"] = "ADLSGen2-CosmosView";
    DataType["MTParquet"] = "MT-Parquet";
})(DataType || (DataType = {}));
export var StorageType;
(function (StorageType) {
    StorageType["Cosmos"] = "Cosmos";
    StorageType["AzureBlob"] = "AzureBlob";
    StorageType["ADLSGen2"] = "ADLSGen2";
    StorageType["ADLSGen2CosmosView"] = "ADLSGen2CosmosView";
    StorageType["MT"] = "MT";
})(StorageType || (StorageType = {}));
export var FileFormat;
(function (FileFormat) {
    FileFormat["CosmosView"] = "CosmosView";
    FileFormat["Parquet"] = "Parquet";
})(FileFormat || (FileFormat = {}));
export const dataSourceDataTypeList = [
    {
        LocationProperties: {
            DataPath: 'String',
            VC: 'String',
            Cluster: 'String',
        },
        DataType: DataType.CosmosCosmosView,
        StorageType: StorageType.Cosmos,
        FileFormat: FileFormat.CosmosView,
    },
    {
        LocationProperties: {
            DataPath: 'String',
            StorageAccount: 'String',
            Container: 'String',
        },
        DataType: DataType.AzureBlobParquet,
        StorageType: StorageType.AzureBlob,
        FileFormat: FileFormat.Parquet,
    },
    {
        LocationProperties: {
            DataPath: 'String',
            StorageAccount: 'String',
            Container: 'String',
            KeyVaultAuthentication: {
                Url: 'String',
                SecretName: 'String',
            },
            //ServicePrincipalName: 'String'
        },
        DataType: DataType.ADLSGen2Parquet,
        StorageType: StorageType.ADLSGen2,
        FileFormat: FileFormat.Parquet,
    },
    {
        LocationProperties: {
            DataPath: 'String',
            StorageAccount: 'String',
            Container: 'String',
        },
        DataType: DataType.ADLSGen2CosmosView,
        StorageType: StorageType.ADLSGen2CosmosView,
        FileFormat: FileFormat.CosmosView,
    },
    {
        LocationProperties: {
            EndPoint: 'String',
            DataPath: 'String',
            Region: 'String',
            SubCluster: 'String',
        },
        DataType: DataType.MTParquet,
        StorageType: StorageType.MT,
        FileFormat: FileFormat.Parquet,
    },
];
export const sampleDataSourceDataTypeList = [
    {
        LocationProperties: {
            DataPath: 'String',
            VC: 'String',
            Cluster: 'String',
        },
        DataType: DataType.CosmosCosmosView,
        StorageType: StorageType.Cosmos,
        FileFormat: FileFormat.CosmosView,
    },
    {
        LocationProperties: {
            DataPath: 'String',
            StorageAccount: 'String',
            Container: 'String',
        },
        DataType: DataType.AzureBlobParquet,
        StorageType: StorageType.AzureBlob,
        FileFormat: FileFormat.Parquet,
    },
    {
        LocationProperties: {
            DataPath: 'String',
            StorageAccount: 'String',
            Container: 'String',
            KeyVaultAuthentication: {
                Url: 'String',
                SecretName: 'String',
            },
        },
        DataType: DataType.ADLSGen2Parquet,
        StorageType: StorageType.ADLSGen2,
        FileFormat: FileFormat.Parquet,
    },
];
export const getFileFormat = (props) => {
    let FileFormat = '';
    let storageType = props.storageType;
    _.each(dataSourceDataTypeList, (item, key) => {
        if (item.StorageType === storageType) {
            FileFormat = item.FileFormat;
        }
    });
    return FileFormat;
};
export const getDataSourceTypeLocation = (props) => {
    let locationProperties = {};
    let storageType = props.storageType;
    _.each(dataSourceDataTypeList, (item, key) => {
        if (item.StorageType === storageType && props.storageList) {
            locationProperties = {
                DataPath: props.storageList.DataPath,
                EndPoint: props.storageList.EndPoint,
                VC: props.storageList.VC,
                Cluster: props.storageList.Cluster,
                StorageAccount: props.storageList.StorageAccount,
                Container: props.storageList.Container,
                KeyVaultAuthentication: props.storageType === DataLocationStorageType.ADLSGen2 &&
                    (props.authenticationType === AuthenticationType.Secret || (!props.authenticationId && !props.managedIdentityId))
                    ? {
                        Url: props.storageList.Url,
                        SecretName: props.storageList.SecretName,
                    }
                    : undefined,
                ServicePrincipalName: props.storageList.ServicePrincipalName,
            };
        }
    });
    return locationProperties;
};
export var CosomosViewDefaultDate;
(function (CosomosViewDefaultDate) {
    CosomosViewDefaultDate["Start"] = "\"#Start#\"";
    CosomosViewDefaultDate["End"] = "\"#End#\"";
})(CosomosViewDefaultDate || (CosomosViewDefaultDate = {}));
export var CosmosViewDefaultDatePlaceholder;
(function (CosmosViewDefaultDatePlaceholder) {
    CosmosViewDefaultDatePlaceholder["Start"] = "e.g. StartDate";
    CosmosViewDefaultDatePlaceholder["End"] = "e.g. EndDate";
})(CosmosViewDefaultDatePlaceholder || (CosmosViewDefaultDatePlaceholder = {}));
export const getCosmosViewStartEndDefaultValue = (name) => {
    if (compareIgnoreCase('start', name)) {
        return '-12';
    }
    else {
        return '-11';
    }
};
export const getCosmosViewDefaultParameter = () => {
    return [
        {
            Name: '',
            Type: 'System.String',
            Value: CosomosViewDefaultDate.Start,
            SampleValue: getCosmosViewStartEndDefaultValue('start'),
            delete: notDeleteKey,
            required: {
                Name: 'Required',
                Type: '',
                Value: '',
                SampleValue: '',
            },
            placeholder: {
                Name: 'e.g. StartDate',
                Value: 'eg: "2020-01-01"',
                SampleValue: 'eg: today("-12")',
            },
        },
        {
            Name: '',
            Type: 'System.String',
            Value: CosomosViewDefaultDate.End,
            SampleValue: getCosmosViewStartEndDefaultValue('end'),
            delete: notDeleteKey,
            required: {
                Name: 'Required',
                Type: '',
                Value: '',
                SampleValue: '',
            },
            placeholder: {
                Name: 'e.g. EndDate',
                Value: 'eg: "2020-01-01"',
                SampleValue: 'eg: today("-11")',
            },
        },
    ];
};
export const genErrorMessageDataLocationInfo = (storageList) => {
    if (!storageList || Object.getOwnPropertyNames(storageList).length <= 0) {
        return {
            DataPath: '',
            VC: '',
            Cluster: '',
        };
    }
    else {
        return storageList;
    }
};
export const genErrorMessageParameterInfo = (parameters, IsCosmosType) => {
    if (parameters && parameters.length > 0) {
        _.each(parameters, (item, key) => {
            if (item.Name === '') {
                item.required.Name = 'Required';
            }
            if (item.Type === '') {
                item.required.Type = 'Required';
            }
            if (item.Value === '') {
                item.required.Value = 'Required';
            }
            else {
                if (!IsCosmosType && item.Type === parameterType.SystemString) {
                    item.required.Value = '';
                }
                else {
                    item.required.Value = getValidateMessage(item.Type, item.Value);
                }
            }
            if (item.SampleValue !== '') {
                if (IsCosmosType && (key === 0 || key === 1)) {
                    item.required.SampleValue = getValidateMessage(parameterType.CosmosDateNumber + key ? 'start' : 'end', item.SampleValue);
                }
                else {
                    if (!IsCosmosType && item.Type === parameterType.SystemString) {
                        item.required.Value = '';
                    }
                    else {
                        item.required.SampleValue = getValidateMessage(item.Type, item.SampleValue);
                    }
                }
            }
            parameters = [
                ...parameters.slice(0, key),
                {
                    ...item,
                },
                ...parameters.slice(key + 1),
            ];
        });
    }
    return parameters;
};
export const genErrorMessageAvailabilityStreamInfo = (streams) => {
    if (streams && streams.length > 0) {
        _.each(streams, (item, key) => {
            if (item.DataPath === '') {
                item.required.DataPath = 'Required';
            }
            streams = [
                ...streams.slice(0, key),
                {
                    ...item,
                },
                ...streams.slice(key + 1),
            ];
        });
    }
    return streams;
};
export const genErrorMessageDataSourceName = (dataSourceName) => {
    if (dataSourceName) {
        const dataSourceNameValueRegex = /^([\w][\w ]{0,126}[\w]$)|^([\w]{1,128})$/;
        if (!dataSourceNameValueRegex.test(dataSourceName)) {
            return 'Alphanumeric and underscore allowed.';
        }
    }
    else {
        return 'Required';
    }
    return '';
};
export const genErrorMessageOverrideDataSourceName = (primaryDataSourceName, dataSourceName) => {
    if (dataSourceName && primaryDataSourceName) {
        const dataSourceOverrideNameValueRegex = /^([\w-][\w- ]{0,126}[\w-]$)|^([\w-]{1,128})$/;
        const error = !dataSourceOverrideNameValueRegex.test(primaryDataSourceName + '-' + dataSourceName)
            ? 'Alphanumeric, hyphen and underscore allowed.'
            : '';
        if (!!error) {
            return error;
        }
    }
    else {
        return 'Required';
    }
    return '';
};
export const validateBasicInfo = (values, workspaceId) => {
    const errors = {};
    if (genErrorMessageDataSourceName(values.name)) {
        errors.name = genErrorMessageDataSourceName(values.name);
    }
    if (!values.isUTC) {
        errors.isUTC = 'Required';
    }
    if (EnvironmentService.enableSampleDataSource() && !values.dataSourceType) {
        errors.dataSourceType = 'Required';
    }
    if (isClassicWorkspaceById(workspaceId) && (!values.owners || values.owners.length === 0)) {
        errors.owners = 'Need at least 1 owner';
    }
    return errors;
};
export const validateOverrideBasicInfo = (FromName, values) => {
    const errors = {};
    if (genErrorMessageOverrideDataSourceName(FromName, values.name)) {
        errors.name = genErrorMessageOverrideDataSourceName(FromName, values.name);
    }
    return errors;
};
const isURLValid = (url) => {
    try {
        new URL(url);
    }
    catch (_) {
        return 'URL format is invalid';
    }
    return '';
};
export const validateDataLocationInfo = (values, existingErrors, workspaceId, isCreate) => {
    var _a;
    if (!values.storageType) {
        existingErrors.storageType = 'Required';
    }
    if (values.storageType === DataLocationStorageType.MT) {
        if (!values.storageMTList || values.storageMTList.length <= 0) {
            existingErrors.storageMTList = 'Required';
        }
        else {
            _.each(MTLocation[0].required, (item, key) => {
                if (!values.storageMTList[0][key]) {
                    existingErrors.storageMTList = 'Required';
                }
            });
        }
    }
    else {
        if (!values.storageList || Object.getOwnPropertyNames(values.storageList).length <= 0) {
            existingErrors.storageList = {
                DataPath: 'Required',
            };
        }
        else {
            _.each(values.storageList, (item, key) => {
                if (key.toLowerCase() === 'url') {
                    if (values.storageType === DataLocationStorageType.ADLSGen2) {
                        // switch dropdown
                        if (values === null || values === void 0 ? void 0 : values.authenticationType) {
                            if (showMSIOption(workspaceId) && (values === null || values === void 0 ? void 0 : values.authenticationType) === AuthenticationType.ManagedIdentity) {
                                if (!values.managedIdentityId) {
                                    existingErrors.storageList = {
                                        ManagedIdentityName: 'Required',
                                    };
                                }
                            }
                            else if ((values === null || values === void 0 ? void 0 : values.authenticationType) === AuthenticationType.ServicePrincipal) {
                                if (!values.authenticationId) {
                                    existingErrors.storageList = {
                                        ServicePrincipalName: 'Required',
                                    };
                                }
                            }
                            else {
                                if (!item) {
                                    existingErrors.storageList = {
                                        Url: 'Required',
                                    };
                                }
                                else if (isURLValid(item)) {
                                    existingErrors.storageList = {
                                        Url: isURLValid(item),
                                    };
                                }
                            }
                        }
                        else {
                            // create first time
                            if (isCreate && showMSIOption(workspaceId) && (values === null || values === void 0 ? void 0 : values.managedIdentityId) === undefined) {
                                if (!values.managedIdentityId) {
                                    existingErrors.storageList = {
                                        ManagedIdentityName: 'Required',
                                    };
                                }
                                else {
                                    if (!item) {
                                        existingErrors.storageList = {
                                            Url: 'Required',
                                        };
                                    }
                                    else if (isURLValid(item)) {
                                        existingErrors.storageList = {
                                            Url: isURLValid(item),
                                        };
                                    }
                                }
                            }
                        }
                    }
                    else {
                        if (!item) {
                            existingErrors.storageList = {
                                Url: 'Required',
                            };
                        }
                        else if (isURLValid(item)) {
                            existingErrors.storageList = {
                                Url: isURLValid(item),
                            };
                        }
                    }
                }
                else if (key.toLowerCase() === 'secretname') {
                    if (values.storageType === DataLocationStorageType.ADLSGen2) {
                        // switch dropdown
                        if (showMSIOption(workspaceId) && (values === null || values === void 0 ? void 0 : values.authenticationType) === AuthenticationType.ManagedIdentity) {
                            if (!values.managedIdentityId) {
                                existingErrors.storageList = {
                                    ManagedIdentityName: 'Required',
                                };
                            }
                        }
                        else if (values === null || values === void 0 ? void 0 : values.authenticationType) {
                            if ((values === null || values === void 0 ? void 0 : values.authenticationType) === AuthenticationType.ServicePrincipal) {
                                if (!values.authenticationId) {
                                    existingErrors.storageList = {
                                        ServicePrincipalName: 'Required',
                                    };
                                }
                            }
                            else {
                                if (!item) {
                                    existingErrors.storageList = {
                                        SecretName: 'Required',
                                    };
                                }
                            }
                        }
                        else {
                            // create first time
                            if (isCreate && showMSIOption(workspaceId) && (values === null || values === void 0 ? void 0 : values.managedIdentityId) === undefined) {
                                if (!values.managedIdentityId) {
                                    existingErrors.storageList = {
                                        ManagedIdentityName: 'Required',
                                    };
                                }
                                else {
                                    if (!item) {
                                        existingErrors.storageList = {
                                            SecretName: 'Required',
                                        };
                                    }
                                }
                            }
                        }
                    }
                    else {
                        if (!item) {
                            existingErrors.storageList = {
                                SecretName: 'Required',
                            };
                        }
                    }
                }
                else if (!item) {
                    existingErrors.storageList = {
                        DataPath: 'Required',
                    };
                }
                else {
                    if (key.toLowerCase() === 'cluster' && !validateCluster(item)) {
                        existingErrors.storageList = {
                            Cluster: 'Required',
                        };
                    }
                }
            });
        }
    }
    if (values.storageType === DataLocationStorageType.AzureBlob ||
        (values.storageType === DataLocationStorageType.Cosmos && isCreate)) {
        if (showMSIOption(workspaceId) &&
            (!values.authenticationType || values.authenticationType === AuthenticationType.ManagedIdentity) &&
            !values.managedIdentityId) {
            existingErrors.storageList = {
                ManagedIdentityName: 'Required',
            };
        }
    }
    else if ((values.storageType === DataLocationStorageType.ADLSGen2CosmosView ||
        values.storageType === DataLocationStorageType.ADLSGen2) &&
        isCreate) {
        if (showMSIOption(workspaceId)) {
            if ((!values.authenticationType || values.authenticationType === AuthenticationType.ManagedIdentity) &&
                !values.managedIdentityId) {
                existingErrors.storageList = {
                    ManagedIdentityName: 'Required',
                };
            }
            else if (values.authenticationType === AuthenticationType.ServicePrincipal && !values.authenticationId) {
                existingErrors.storageList = {
                    ServicePrincipalName: 'Required',
                };
            }
        }
        else {
            if ((!values.authenticationType || values.authenticationType === AuthenticationType.ServicePrincipal) &&
                !values.authenticationId) {
                existingErrors.storageList = {
                    ServicePrincipalName: 'Required',
                };
            }
        }
    }
    const retentionDays = Number(values.retentionDays);
    if (values.retentionDays && isNaN(retentionDays)) {
        existingErrors.retentionDays = 'Please enter a valid number';
    }
    else if (retentionDays < 0) {
        existingErrors.retentionDays = 'The valid data period must be a positive integer.';
    }
    const retentionErrorMsg = (_a = values.retentionErrorMsg) !== null && _a !== void 0 ? _a : '';
    if ((retentionErrorMsg === null || retentionErrorMsg === void 0 ? void 0 : retentionErrorMsg.length) > 2048) {
        existingErrors.retentionErrorMsg = 'The length of the message must be less than 2048 characters.';
    }
    return existingErrors;
};
const genSepcialColumnsDict = (values) => {
    let dict = {};
    dict = _.countBy([...values.randomizationList, ...values.flightList, ...values.timestampList], (i) => i.ColumnName);
    return dict;
};
const checkMiddleBrackets = (value) => {
    let frontBracketList = [];
    for (const char of value) {
        if (char === '[') {
            if (frontBracketList.length === 0) {
                frontBracketList.push('[');
            }
            else {
                return false;
            }
        }
        else if (char === ']') {
            if (frontBracketList.length === 1) {
                frontBracketList.pop();
            }
            else {
                return false;
            }
        }
    }
    return frontBracketList.length === 0;
};
const errorDuplicateSpecialColumn = 'Column with this name is already defined.';
export const validateSpecialColumnsInfo = (values, existingErrors, initialValues) => {
    let hasErrors = false;
    const dict = genSepcialColumnsDict(values);
    if (values.randomizationList && values.randomizationList.length > 0) {
        const randomizationListErrors = _.map(values.randomizationList, (randomization, index) => {
            var _a, _b, _c, _d, _e;
            const error = {};
            if (((_b = (_a = values.dataContractErrorDetails) === null || _a === void 0 ? void 0 : _a.AssignmentUnits[index]) === null || _b === void 0 ? void 0 : _b.Error) &&
                values.randomizationList[index].ColumnName === initialValues.randomizationList[index].ColumnName &&
                _.trim((_c = values.dataContractErrorDetails) === null || _c === void 0 ? void 0 : _c.AssignmentUnits[index].Error) !== errorDuplicateSpecialColumn) {
                error.ColumnName = (_d = values.dataContractErrorDetails) === null || _d === void 0 ? void 0 : _d.AssignmentUnits[index].Error;
            }
            if (_.isEmpty(randomization.ColumnName)) {
                error.ColumnName = 'Column name must not be empty.';
            }
            if (randomization.NGPColumnTag) {
                if (new RegExp(/\[|\]/).test(randomization.NGPColumnTag) &&
                    ((_e = randomization.NGPColumnTag.match(/(\[((?!\[).)*#ColumnName#((?!\]).)*\])+/g)) !== null && _e !== void 0 ? _e : []).join('').length !==
                        randomization.NGPColumnTag.length)
                    error.NGPColumnTag = 'every NGP Column tag should contain "#ColumnName#"';
                else if (!randomization.NGPColumnTag.includes('#ColumnName#'))
                    error.NGPColumnTag = 'NGP Column tag should contain "#ColumnName#"';
            }
            if (randomization.NGPStreamTag && !checkMiddleBrackets(randomization.NGPStreamTag)) {
                error.NGPStreamTag = 'The brackets not match';
            }
            if (randomization.ColumnName && dict[randomization.ColumnName] && dict[randomization.ColumnName] >= 2) {
                error.ColumnName = errorDuplicateSpecialColumn;
            }
            hasErrors = !_.isEmpty(error) ? true : hasErrors;
            return error;
        });
        if (hasErrors && !!randomizationListErrors) {
            existingErrors = {
                ...existingErrors,
                randomizationList: randomizationListErrors,
            };
        }
    }
    else {
        existingErrors.randomizationList = 'Must create at least one assignment unit column';
    }
    if (values.flightList && values.flightList.length > 0) {
        const flightListErrors = _.map(values.flightList, (flight, index) => {
            var _a, _b, _c, _d;
            const error = {};
            if (((_b = (_a = values.dataContractErrorDetails) === null || _a === void 0 ? void 0 : _a.Flight[index]) === null || _b === void 0 ? void 0 : _b.Error) &&
                values.flightList[index].ColumnName === initialValues.flightList[index].ColumnName &&
                _.trim((_c = values.dataContractErrorDetails) === null || _c === void 0 ? void 0 : _c.Flight[index].Error) !== errorDuplicateSpecialColumn) {
                error.ColumnName = (_d = values.dataContractErrorDetails) === null || _d === void 0 ? void 0 : _d.Flight[index].Error;
            }
            if (_.isEmpty(flight.ColumnName)) {
                error.ColumnName = 'Column name must not be empty.';
            }
            if (_.isEmpty(flight.Format)) {
                error.Format = 'Format must not be empty.';
            }
            if (flight.ColumnName && dict[flight.ColumnName] && dict[flight.ColumnName] >= 2) {
                error.ColumnName = errorDuplicateSpecialColumn;
            }
            hasErrors = !_.isEmpty(error) ? true : hasErrors;
            return error;
        });
        if (hasErrors && !!flightListErrors) {
            existingErrors = {
                ...existingErrors,
                flightList: flightListErrors,
            };
        }
    }
    else {
        existingErrors.flightList = 'Must create at least one flight column';
    }
    if (values.timestampList && values.timestampList.length > 0) {
        const timestampListErrors = _.map(values.timestampList, (timestamp, index) => {
            var _a, _b, _c, _d;
            const error = {};
            if (((_b = (_a = values.dataContractErrorDetails) === null || _a === void 0 ? void 0 : _a.TimeStamp[index]) === null || _b === void 0 ? void 0 : _b.Error) &&
                values.timestampList[index].ColumnName === initialValues.timestampList[index].ColumnName &&
                _.trim((_c = values.dataContractErrorDetails) === null || _c === void 0 ? void 0 : _c.TimeStamp[index].Error) !== errorDuplicateSpecialColumn) {
                error.ColumnName = (_d = values.dataContractErrorDetails) === null || _d === void 0 ? void 0 : _d.TimeStamp[index].Error;
            }
            if (_.isEmpty(timestamp.ColumnName)) {
                error.ColumnName = 'Column name must not be empty.';
            }
            if (timestamp.ColumnName && dict[timestamp.ColumnName] && dict[timestamp.ColumnName] >= 2) {
                error.ColumnName = errorDuplicateSpecialColumn;
            }
            hasErrors = !_.isEmpty(error) ? true : hasErrors;
            return error;
        });
        if (hasErrors && !!timestampListErrors) {
            existingErrors = {
                ...existingErrors,
                timestampList: timestampListErrors,
            };
        }
    }
    else {
        existingErrors.timestampList = 'Must create at least one timestamp column';
    }
    return existingErrors;
};
export const validateParameterInfo = (values, existingErrors) => {
    if (values.parameterList && values.parameterList.length > 0) {
        _.each(values.parameterList, (item, key) => {
            if (item['required']) {
                _.each(item['required'], (subItem) => {
                    if (subItem !== '') {
                        existingErrors.parameterList = 'Required';
                    }
                });
            }
        });
    }
    return existingErrors;
};
export const validateAvailabilityStreamInfo = (values, existingErrors) => {
    if (values.streamList && values.streamList.length > 0) {
        _.each(values.streamList, (item, key) => {
            if (item['required']) {
                _.each(item['required'], (subItem) => {
                    if (subItem.length > 0) {
                        existingErrors.streamList = 'Required';
                    }
                });
            }
        });
    }
    return existingErrors;
};
export const GetRandomizationListTouched = (items) => {
    const result = _.map(items, (item) => {
        return {
            ColumnName: true,
            NGPColumnTag: true,
        };
    });
    return result;
};
export const GetFlightListTouched = (items) => {
    const result = _.map(items, (item) => {
        return {
            ColumnName: true,
            Format: true,
        };
    });
    return result;
};
export const GetTimestampListTouched = (items) => {
    const result = _.map(items, (item) => {
        return {
            ColumnName: true,
        };
    });
    return result;
};
export const getProfileJobConfigurationFrequency = (option) => {
    switch (option) {
        case ProfilingOptions.Weekly:
            return '168.00:00:00';
        case ProfilingOptions.Daily:
            return '24.00:00:00';
        case ProfilingOptions.Manual:
        default:
            return null;
    }
};
export const getProfileJobConfigurationFrequencyFriendlyName = (option) => {
    switch (option) {
        case '168.00:00:00':
            return ProfilingOptions.Weekly;
        case '24.00:00:00':
            return ProfilingOptions.Daily;
        default:
            return ProfilingOptions.Manual;
    }
};
export const showNGPColumnsInSpecialColumn = (storageType) => {
    return storageType === 'Cosmos' || storageType === 'ADLSGen2CosmosView';
};
export const showMSIOption = (workspaceId) => {
    return EnvironmentService.enableMSIForDSMS() && !isClassicWorkspaceById(workspaceId);
};

//# sourceMappingURL=DataSourceFormikSettingsUtils.js.map
